// extracted by mini-css-extract-plugin
export default {"container":"ServiceList_container__YBtoT","row":"ServiceList_row__kyGs7","title":"ServiceList_title__Y5ky2","main":"ServiceList_main__AtIHY","btn":"ServiceList_btn__qM3iY"};